/* Berry theme · cart (D4a). Ported from the prototype (site.js renderBag / addToBag, pages.js cart page) onto Shopify's
   Ajax Cart API and the Section Rendering API, so the page never reloads:
     · BV.addToCart(variantId, qty, trigger): adds, re-renders the cart drawer (section cart-drawer) in the same request,
       updates every header count and opens the drawer (Theme settings › Cart › After Add to cart: drawer or page)
     · drawer and cart page: quantity − / +, Remove, Move to wishlist, Secure checkout (Shopify's native checkout through
       the cart form)
     · suggestions: Often worn together (drawer) and Complete the look (cart page) from Shopify's Product
       Recommendations API (complementary, else related), rendered by the section cart-recommendations
   Loaded on every page (the drawer lives in the layout). Needs berry-theme.js (drawers). */
(function () {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const BV = (window.BV = window.BV || {});
  const T = window.BV_THEME || { t: {}, routes: {} };
  const R = T.routes || {};
  const ROOT = (R.root || '/').replace(/\/?$/, '/');
  const t = (k, vars) => String((T.t || {})[k] || k).replace(/\{\{\s*(\w+)\s*\}\}/g, (_, v) => (vars && vars[v] !== undefined ? vars[v] : ''));
  const toast = (msg, icon) => (BV.toast ? BV.toast(msg, icon) : BV.announce && BV.announce(msg));
  const announce = (msg) => { const live = $('#bv-live'); if (live) { live.textContent = ''; setTimeout(() => { live.textContent = msg; }, 30); } };
  const DRAWER_SECTION = 'cart-drawer';
  const page = () => $('[data-cart-page]');
  const sectionsWanted = () => [DRAWER_SECTION, page() && page().dataset.sectionId].filter(Boolean);
  const json = (r) => r.json().then((j) => { if (!r.ok) { const e = new Error(j.description || j.message || t('cart_error')); e.status = r.status; throw e; } return j; });
  const post = (url, body) => fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ ...body, sections: sectionsWanted().join(','), sections_url: location.pathname }) }).then(json);
  const parse = (html) => new DOMParser().parseFromString(html, 'text/html');

  // ---------------------------------------------------------------- Counts (header icons, labels)
  const setCount = (n) => {
    $$('[data-bag-count]').forEach((el) => { el.textContent = n; el.hidden = n === 0; });
    $$('[data-cart-icon]').forEach((a) => a.setAttribute('aria-label', n === 1 ? t('cart_label_one') : n ? t('cart_label_count', { count: n }) : t('cart_label_empty')));
  };

  // ---------------------------------------------------------------- Render the sections that came back with a change
  // Focus stays where it was: the same control of the same line, else the next sensible control.
  const focusKey = () => {
    const a = document.activeElement;
    if (!a || !a.closest('[data-cart-drawer], [data-cart-page]')) return null;
    const line = a.closest('[data-line]');
    const scope = a.closest('[data-cart-drawer]') ? 'drawer' : 'page';
    if (line) return { scope, line: line.dataset.line, sel: a.matches('[data-cart-step="1"]') ? '[data-cart-step="1"]' : a.matches('[data-cart-step="-1"]') ? '[data-cart-step="-1"]' : '[data-cart-remove]' };
    return { scope, id: a.id };
  };
  const restoreFocus = (k) => {
    if (!k) return;
    const scope = k.scope === 'drawer' ? $('[data-cart-drawer]') : page();
    if (!scope) return;
    let el = k.line ? $(`[data-line="${CSS.escape(k.line)}"] ${k.sel}`, scope) : (k.id && document.getElementById(k.id));
    if (el && el.disabled) el = $(`[data-line="${CSS.escape(k.line)}"] [data-cart-step="1"]`, scope);
    if (!el) el = $('[data-cart-remove]', scope) || $('.bv-bag__empty a, .bv-cartpage__empty a', scope) || $('[data-drawer-close]', scope);
    if (el) el.focus({ preventScroll: true });
  };
  const render = (sections) => {
    if (!sections) return;
    const k = focusKey();
    const drawerHtml = sections[DRAWER_SECTION];
    if (drawerHtml) {
      const next = $('[data-cart-drawer]', parse(drawerHtml));
      const now = $('[data-cart-drawer]');
      if (next && now) {
        now.innerHTML = next.innerHTML;
        ['count', 'firstProduct'].forEach((d) => { now.dataset[d] = next.dataset[d]; });
        setCount(Number(next.dataset.count || 0));
      }
    }
    const pg = page();
    if (pg && sections[pg.dataset.sectionId]) {
      const next = $('[data-cart-page]', parse(sections[pg.dataset.sectionId]));
      if (next) pg.innerHTML = next.innerHTML;
    }
    restoreFocus(k);
    BV.watchImages && BV.watchImages(document);
    document.dispatchEvent(new CustomEvent('bv:cart-rendered'));
    suggest();
  };
  BV.cartRender = render;

  // ---------------------------------------------------------------- Add (every Add to cart of the theme comes here)
  const openCart = (trigger) => {
    if ((T.cart && T.cart.type) === 'page') { location.href = R.cart || `${ROOT}cart`; return; }
    if (page()) { const top = page().getBoundingClientRect().top + scrollY - 20; scrollTo({ top: Math.max(0, top), behavior: 'smooth' }); return; }
    if (BV.openDrawer) BV.openDrawer('bag', trigger);
  };
  BV.addToCart = (variantId, qty = 1, trigger, properties) => post(R.cart_add || `${ROOT}cart/add.js`, { items: [{ id: Number(variantId), quantity: qty, ...(properties ? { properties } : {}) }] })
    .then((res) => {
      render(res.sections);
      const item = (res.items || [])[0];
      if (item) announce(t('added_to_cart', { name: item.product_title }));
      const count = Number(($('[data-cart-drawer]') || {}).dataset ? $('[data-cart-drawer]').dataset.count : 0);
      document.dispatchEvent(new CustomEvent('bv:cart', { detail: { variantId, trigger, item, count } }));
      openCart(trigger);
      return res;
    });
  // berry-shop.js shows a toast after an add when the drawer cannot open (cart page setting); the drawer is enough
  BV.cartOpensDrawer = () => (T.cart && T.cart.type) !== 'page' && !page();

  // ---------------------------------------------------------------- Change a line (quantity, remove)
  const busyLine = (line, on) => { if (!line) return; line.classList.toggle('is-updating', on); if (on) line.setAttribute('aria-busy', 'true'); else line.removeAttribute('aria-busy'); };
  const change = (key, quantity, line) => {
    busyLine(line, true);
    return post(R.cart_change || `${ROOT}cart/change.js`, { id: key, quantity })
      .then((res) => { render(res.sections); return res; })
      .catch((e) => { busyLine(line, false); toast(e.message || t('cart_error'), 'i-info'); throw e; });
  };
  BV.cartChange = change;
  const onClick = (e) => {
    const line = e.target.closest('[data-line]');
    if (!line || !e.target.closest('[data-cart-drawer], [data-cart-page]')) return;
    const key = line.dataset.line;
    const name = line.dataset.name || '';
    const qty = Number($('output', line) ? $('output', line).textContent : 1);
    const step = e.target.closest('[data-cart-step]');
    if (step) {
      e.preventDefault();
      const next = Math.max(1, qty + Number(step.dataset.cartStep));
      if (next === qty) return;
      change(key, next, line).then(() => announce(t('cart_quantity', { name, count: next }))).catch(() => {});
      return;
    }
    if (e.target.closest('[data-cart-remove]')) {
      e.preventDefault();
      change(key, 0, line).then(() => toast(t('cart_removed', { name }), 'i-check')).catch(() => {});
      return;
    }
    if (e.target.closest('[data-cart-wish]')) {
      e.preventDefault();
      const handle = line.dataset.handle;
      change(key, 0, line).then(() => {
        if (BV.wish && BV.wish.add) BV.wish.add(handle, line.dataset.value || undefined);
        toast(t('cart_moved', { name }), 'i-heart');
      }).catch(() => {});
    }
  };
  document.addEventListener('click', onClick);

  // ---------------------------------------------------------------- Checkout: the loading line while Shopify opens checkout
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!form.closest('[data-cart-drawer], [data-cart-page]')) return;
    const btn = e.submitter && e.submitter.matches('[data-checkout]') ? e.submitter : null;
    if (!btn) return;
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
  });
  addEventListener('pageshow', (e) => { if (e.persisted) $$('[data-checkout].is-loading').forEach((b) => { b.classList.remove('is-loading'); b.removeAttribute('aria-busy'); }); });

  // ---------------------------------------------------------------- Suggestions (Often worn together · Complete the look)
  const cache = new Map();
  const recoUrl = (id, intent) => `${R.product_recommendations || `${ROOT}recommendations/products`}?product_id=${id}&limit=10&intent=${intent}&section_id=cart-recommendations`;
  const getReco = (id) => {
    const sig = `${id}|${$$('[data-cart-drawer] [data-line]').map((l) => l.dataset.line).join(',')}`;
    if (!cache.has(sig)) {
      cache.set(sig, fetch(recoUrl(id, 'complementary')).then((r) => r.text()).then((html) => {
        const doc = parse(html);
        if ($$('[data-reco-drawer] li', doc).length) return doc;
        return fetch(recoUrl(id, 'related')).then((r) => r.text()).then(parse);
      }).catch(() => null));
    }
    return cache.get(sig);
  };
  function suggest() {
    const drawer = $('[data-cart-drawer]');
    const id = drawer && drawer.dataset.firstProduct;
    const box = drawer && $('[data-bag-together]', drawer);
    const look = $('[data-cart-look]');
    if (!id || (!box && !look)) return;
    getReco(id).then((doc) => {
      if (!doc) return;
      const items = $$('[data-reco-drawer] li', doc);
      const nowBox = $('[data-cart-drawer] [data-bag-together]');
      if (nowBox && items.length) {
        const n = Number(nowBox.dataset.limit || 2);
        nowBox.innerHTML = `<p class="bv-bag__together-title">${nowBox.dataset.title || ''}</p><ul>${items.slice(0, n).map((li) => li.outerHTML).join('')}</ul>`;
        nowBox.hidden = false;
        BV.watchImages && BV.watchImages(nowBox);
      }
      const nowLook = $('[data-cart-look]');
      const cards = $$('[data-reco-cards] > .bv-card', doc);
      if (nowLook && cards.length) {
        const grid = $('[data-look-grid]', nowLook);
        grid.dataset.frame = cards.some((c) => c.dataset.clothing === 'true') ? 'portrait' : 'square';
        grid.innerHTML = cards.map((c) => c.outerHTML).join('');
        nowLook.hidden = false;
        grid.dispatchEvent(new CustomEvent('bv:cards', { bubbles: true }));
        BV.watchImages && BV.watchImages(grid);
      }
    });
  }
  const bag = $('[data-cart-drawer]');
  if (bag) bag.addEventListener('bv:drawer-open', suggest);
  if (page()) suggest();

  // The header cart icon opens the drawer (a link to the cart page without JavaScript or with the page setting)
  document.addEventListener('click', (e) => {
    const a = e.target.closest('[data-cart-icon]');
    if (!a || (T.cart && T.cart.type) === 'page' || !BV.openDrawer || e.metaKey || e.ctrlKey) return;
    e.preventDefault();
    BV.openDrawer('bag', a);
  });

  // A page restored from the back/forward cache shows the cart as it is now
  addEventListener('pageshow', (e) => {
    if (!e.persisted) return;
    fetch(`${location.pathname}?sections=${sectionsWanted().join(',')}`).then((r) => r.json()).then(render).catch(() => {});
  });
})();
